import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { ProtectedRoute } from '../components/ProtectedRoute';

// Admin Components
import DashboardPage from '../pages/dashboard';
import OnlyFansAccountsPage from '../pages/accounts/onlyfans';
import CreatorsPage from '../pages/users/creators';
import CreatorDetailsPage from '../pages/users/creators/creator-details';
import PartnersPage from '../pages/users/partners';
import PartnerDetailsPage from '../pages/users/partners/partner-details';
import CPLOffersPage from '../pages/cpl/offers';
import CPLOrdersPage from '../pages/cpl/orders';
import RevshareOffersPage from '../pages/revshare/offers';
import RevshareCampaignsPage from '../pages/revshare/campaigns';
import RevshareBillsPage from '../pages/revshare/bills';
import SettingsPage from '../pages/settings';
import FinancePage from '../pages/finance';
import WithdrawalPage from '../pages/withdrawal';

// Layout
import AdminLayout from './AdminLayout';

const AdminRoutes: React.FC = () => {
  return (
    <ProtectedRoute>
      <AdminLayout>
        <Routes>
          {/* Admin Routes - Require Admin Authentication */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />

          {/* Users Routes */}
          <Route path="/users/creators" element={<CreatorsPage />} />
          <Route path="/users/creators/:id/:tab?" element={<CreatorDetailsPage />} />
          <Route path="/users/partners" element={<PartnersPage />} />
          <Route path="/users/partners/:id/:tab?" element={<PartnerDetailsPage />} />

          {/* Accounts Routes */}
          <Route path="/accounts/onlyfans" element={<OnlyFansAccountsPage />} />

          {/* CPL Routes */}
          <Route path="/cpl/offers" element={<CPLOffersPage />} />
          <Route path="/cpl/orders" element={<CPLOrdersPage />} />

          {/* RevShare Routes */}
          <Route path="/revshare/offers" element={<RevshareOffersPage />} />
          <Route path="/revshare/campaigns" element={<RevshareCampaignsPage />} />
          <Route path="/revshare/bills" element={<RevshareBillsPage />} />

          {/* Account Routes */}
          <Route path="/account/settings" element={<SettingsPage />} />
          <Route path="/account/finance" element={<FinancePage />} />
          <Route path="/account/withdraw" element={<WithdrawalPage />} />

          {/* Add more admin routes here as needed */}
        </Routes>
      </AdminLayout>
    </ProtectedRoute>
  );
};

export default AdminRoutes;
